export default "__VITE_ASSET__BBT2AUyf__"